import MarketMakingOrderBookPanel from "src/Components/MarketMakingOrderBookPanel";
import FuturesSymbolBoard from "./FuturesSymbolBoard";
import useLiveOrderBooks from "src/Hooks/useLiveOrderBooks";
import useOrderBookPolling from "src/Pages/AutomaticMarketMaking/Execusion/useOrderBookPolling";
import {
  FuturesExecutionTaskRow,
  getFuturesExecutionMarketData,
  getFuturesExecutionOrderBook,
} from "src/Requests/futuresMarketMaking";

interface Props { task: FuturesExecutionTaskRow | null }

const ExecutionOrderBook = ({ task }: Props) => {
  const polling = useOrderBookPolling(task?.id, getFuturesExecutionOrderBook);
  const market = useOrderBookPolling(task?.id, getFuturesExecutionMarketData);
  const live = useLiveOrderBooks({
    enabled: !!task,
    instrumentIds: task ? [task.futureInstrumentId] : [],
  });
  const overview = polling.response && "fullOrderBook" in polling.response
    ? polling.response : null;
  const polledOrderBook = overview ? overview.fullOrderBook :
    polling.response && "bestLimitsDto" in polling.response ? polling.response : null;
  const instrumentStatistic = market.response?.instrumentStatistic ?? null;
  const liveDetails = market.response?.liveDetails ?? null;
  const orderBook = live.resolveOrderBook(polledOrderBook, task?.futureInstrumentId);
  const namedOrderBook = orderBook && task ? {
    ...orderBook,
    namad: task.futureSymbol || orderBook.namad,
    fullName: task.futureName || task.futureSymbol || orderBook.fullName,
    tseLink: task.futureTseLink || orderBook.tseLink,
  } : orderBook;

  return <MarketMakingOrderBookPanel
    mode="futures"
    orderBook={namedOrderBook}
    openOrders={task ? overview?.openOrders ?? [] : undefined}
    board={<FuturesSymbolBoard task={task} statistic={instrumentStatistic}
      live={liveDetails} openOrders={overview?.openOrders ?? []} />}
    details={task ? { baseInsPriceLive: liveDetails?.baseInsPriceLive,
      baseInsPriceYesterday: liveDetails?.baseInsPriceYesterday,
      liveFairPrice: liveDetails?.liveFairPrice,
      lastFactorTriggerAt: liveDetails?.lastFactorTriggerAt,
      vwsp: liveDetails?.vwsp, fTheor: liveDetails?.fTheor,
      minPricePermit: instrumentStatistic?.minPricePermit,
      maxPricePermit: instrumentStatistic?.maxPricePermit,
      priceYesterday: instrumentStatistic?.priceYesterday } : null}
  />;
};

export default ExecutionOrderBook;
